class Invoice {
    id = null;
    number = '';
    sequence = 0;
    time_of_issue = null;
    delivery_date = null;
    due_date = null;
    place_of_issue = 'Šibenik, Croatia';
    vat = false;
    amount_with_tax = 0;
    amount_without_tax = 0;
    po_numbers = '';
    office_footer = '';
    entity_header = '';
    entity_footer = '';
    billing_period_from = null;
    billing_period_to = null;
    user_id = null;
    payment_method_id = 1;
    entity_id = null;
    internal_office_id = null;
    internal_office_bank_account_id = null;
    currency_id = 1;
    invoice_sequence_id = null;
    billing_list_id = null;
    cancelled = false;
    gdpr_edit_lock = false;
    cancels = null;
    items = [];
    entity_data = {};
    office_data = {};

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default Invoice;
